// extracted by mini-css-extract-plugin
export default {"component":"HumanResources_component__CQpID","dark":"HumanResources_dark__Nr8FQ"};